// extracted by mini-css-extract-plugin
export default {"userDetail":"UserDetailComponent_userDetail__5cTT4","link":"UserDetailComponent_link__65En+","clickable":"UserDetailComponent_clickable__iKOHi"};